export default __webpack_public_path__ + "static/media/undraw_city_driver_re_0x5e.bdbc80c8.svg";